import { SupabaseConnector } from "../utils/services/SupabaseConnector.ts";
export const supabasePlugin = new SupabaseConnector();


// import { SupabaseClient } from "@supabase/supabase-js";
// import { supabase as supabaseClient, config as supabaseConfig } from "../utils/supabaseClient";

// export const supabasePlugin = {
//   client: null as SupabaseClient | null,
//   config: supabaseConfig,

//   install() {
//     this.client = supabaseClient;
//   },

//   init() {
//     if (!this.client) {
//       this.install();
//     }
//     return this;
//   }
// };

// export default supabasePlugin.init();